import * as React from 'react';

export default function withAsync(importComponent, packageName) {
	return class AsyncComponent extends React.Component {
		constructor(props) {
			super(props);

			this.state = {
				component: null,
			};
		}

		componentDidMount() {
			console.log('Package: ' + packageName);
			importComponent()
				.then(({ default: component }) => this.setState({ component }))
				.catch((err) => console.error(err));
		}

		render() {
			const Component = this.state.component;

			return Component ? <Component {...this.props} /> : null;
		}
	};
}
